"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PluginSetup = void 0;

var tslib_1 = require("tslib");

var bowser_1 = tslib_1.__importDefault(require("bowser"));

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var Errors_1 = require("@skbkontur/plugin-js/lib/common/Errors");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var common_1 = require("../../utils/common");

var Errors_2 = require("../Errors");

var Features_1 = require("./Features");

var constants_1 = require("../../utils/constants");

var features_1 = require("../../utils/features");

var PluginSetup =
/** @class */
function () {
  function PluginSetup() {
    var _this = this;

    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "PluginSetup");
    /**
     * Функция определяет состояние Плагина и Тулбокса.
     * Выбирает доступную версию. Проверяем возможность отката с Плагина на Тулбокс.
     * @returns {Promise<IPluginFullInfo>} информация о состоянии Плагина/Тулбокса.
     */

    this.getPluginFullInfo = function (_a) {
      var unsupportedBrowsers = _a.unsupportedBrowsers,
          supportedOperationSystems = _a.supportedOperationSystems,
          toolboxBrowsers = _a.toolboxBrowsers,
          minPluginVersion = _a.minPluginVersion;
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var plugin, pluginInfo, _b, fallback, isToolboxSupportedByBrowser, toolbox, toolboxInfo;

        return tslib_1.__generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              plugin = new Plugin_1.Plugin();
              return [4
              /*yield*/
              , plugin.getInfo()];

            case 1:
              pluginInfo = _c.sent();
              _b = this.isHostBlocked(pluginInfo);
              if (!_b) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , this.tryToUnblockHost()];

            case 2:
              _b = _c.sent();
              _c.label = 3;

            case 3:
              // пробуем починить ошибку с заблокированным доменом, если нет доступа.
              if (_b) {
                pluginInfo.isBlocked = false;
              }

              isToolboxSupportedByBrowser = common_1.checkBrowser(bowser_1.default, toolboxBrowsers);
              if (!isToolboxSupportedByBrowser) return [3
              /*break*/
              , 5];
              this.log.info("Toolbox is supported by this browser: " + bowser_1.default.name + ", version: " + bowser_1.default.version);
              toolbox = new Plugin_1.Toolbox();
              return [4
              /*yield*/
              , toolbox.getInfo()];

            case 4:
              toolboxInfo = _c.sent();

              if (this.isReady(toolboxInfo)) {
                if (this.isReady(pluginInfo)) {
                  this.log.info('Plugin ready to work. Toolbox ready too. Fallback available');
                  fallback = {
                    plugin: toolbox,
                    flags: Features_1.getFeatureFlags(toolboxInfo.version),
                    pluginInfo: toolboxInfo
                  };
                } else {
                  this.log.info('Plugin not ready to work. Switched to Toolbox'); // заменяем Plugin на Toolbox

                  plugin = toolbox;
                  pluginInfo = toolboxInfo;
                }
              }

              return [3
              /*break*/
              , 6];

            case 5:
              this.log.info("Toolbox isn't supported by this browser: " + bowser_1.default.name + ", version: " + bowser_1.default.version);
              _c.label = 6;

            case 6:
              return [2
              /*return*/
              , {
                // определяем может ли впринципе работать Плагин в этой ОС и браузере
                pluginAvailableError: Features_1.checkSystemRequirements(bowser_1.default, unsupportedBrowsers, supportedOperationSystems),
                plugin: plugin,
                flags: Features_1.getFeatureFlags(pluginInfo.version),
                pluginInfo: pluginInfo,
                state: this.isReadyInfo(pluginInfo, minPluginVersion),
                fallback: fallback
              }];
          }
        });
      });
    };
  }
  /**
   * Не нужно обновлять 2-ю версию Плагина (Тулбокс) всем подряд,
   * т.к. часть клиентов Контура, не имеют технической возможности обновиться с Тулбокса на Плагин.
   * Но часть продуктов готовы отказаться от Тулбокса, для них эта возможность
   * включается через глобальный фича флаг.
   */


  PluginSetup.prototype.isCurrentVersionUpdateable = function (version) {
    var features = features_1.getFeatureList();
    var isNotToolbox = common_1.compareVersions(version, '3.0.0') !== -1;
    return isNotToolbox || features['ToolboxUpdateAvailable'];
  };

  PluginSetup.prototype.isReadyInfo = function (pluginInfo, minPluginVersion) {
    var isObsoleteVersion = minPluginVersion && this.isCurrentVersionUpdateable(pluginInfo.version) && common_1.compareVersions(pluginInfo.version, minPluginVersion) === -1;

    switch (true) {
      case !pluginInfo.isInstalled:
        {
          return {
            ready: false,
            error: new Errors_1.CommonError("Plugin is not ready to work", null, Errors_2.DisplayedErrorCodes.NoPlugin)
          };
        }

      case pluginInfo.isInstalled && pluginInfo.isBlocked:
        {
          return {
            ready: false,
            error: new Errors_1.CommonError("Plugin is not ready to work", null, Errors_2.DisplayedErrorCodes.NotTrustedHost)
          };
        }

      case pluginInfo.isInstalled && isObsoleteVersion:
        {
          return {
            ready: false,
            error: new Errors_1.CommonError('Plugin is obsolete', null, Errors_2.DisplayedErrorCodes.ObsoletePluginVersion, {
              version: pluginInfo.version
            })
          };
        }

      default:
        {
          return {
            ready: true
          };
        }
    }
  };
  /**
   * Вызов стандартного окна получения доступа, путем поиска сертификатов в хранилище.
   */


  PluginSetup.prototype.confirmAccessPopup = function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var e_1;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , new Plugin_1.Plugin().searchCertificate({
              store: {
                name: Plugin_1.StoreName.AddressBook,
                location: Plugin_1.StoreLocation.User
              }
            }, {
              content: false,
              serialNumber: false,
              issuer: false,
              subject: false,
              validFrom: false,
              validTo: false,
              hasPrivateKey: false,
              qualified: false,
              extensions: false,
              cryptoProvider: false,
              containerInfo: false
            })];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , true];

          case 2:
            e_1 = _a.sent();
            return [2
            /*return*/
            , false];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PluginSetup.prototype.isReady = function (pluginInfo) {
    return pluginInfo.isInstalled && !pluginInfo.isBlocked;
  };

  PluginSetup.prototype.isHostBlocked = function (pluginInfo) {
    return pluginInfo.isInstalled && pluginInfo.isBlocked;
  };

  PluginSetup.prototype.tryToUnblockHost = function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var accessConfirmed;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.log.info('Plugin is installed, but access from this host is blocked. Start manual access request');
            return [4
            /*yield*/
            , this.confirmAccessPopup()];

          case 1:
            accessConfirmed = _a.sent();

            if (accessConfirmed) {
              this.log.info("Access granted for host " + window.location.host);
            } else {
              this.log.info("Access denied for host " + window.location.host);
            }

            return [2
            /*return*/
            , accessConfirmed];
        }
      });
    });
  };

  return PluginSetup;
}();

exports.PluginSetup = PluginSetup;